'use client';

import { IProductDetail } from '@/api/types/public';
import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import { colors, font } from '@/theme/zeelool.theme';
import { Box, Typography } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import GoodsDetailCollapse from './GoodsDetailCollapse';

interface FreeGiftProps {
  detail?: IProductDetail;
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
  defaultOpen?: boolean;
  isWeb?: boolean;
}

export default function FreeGift({
  detail,
  SDProductDetailsPageBtnClick,
  defaultOpen = false,
  isWeb = false,
}: FreeGiftProps) {
  const t = useTranslations('goodsDetail');
  // 计算属性转换为内联表达式
  const isShow = detail?.product_content_glass_gift?.status === 1;
  const freeGift = detail?.product_content_glass_gift || {};
  const waiMode = useStore((state) => state.waiMode);

  if (!isShow) {
    return null;
  }

  return (
    <GoodsDetailCollapse
      title={t('freeGift.title')}
      onChange={() => SDProductDetailsPageBtnClick?.('Free Gift')}
      defaultOpen={defaultOpen}
    >
      <Box
        className={`flex flex-col items-center justify-start ${isWeb ? 'p-10 bg-[#f7f7f7] rounded-8' : 'mb-24'}`}
      >
        <Box className={`w-full flex  justify-between ${isWeb ? 'items-center' : 'items-start'}`}>
          <Box
            className={`rounded-[8px] overflow-hidden flex-shrink-0 ${
              isWeb ? 'w-[56px] h-[56px]' : 'w-[100px] h-[100px]'
            }`}
          >
            <Image
              src={freeGift.img || ''}
              alt={freeGift.title || t('freeGift.defaultAlt')}
              width={100}
              height={100}
              className="object-contain"
            />
          </Box>
          <Box
            className={`flex flex-col items-start justify-center w-[220px] ${
              isWeb ? 'flex-1 ml-6' : 'w-[220px]'
            }`}
          >
            <Typography
              sx={{
                fontFamily: font.bb,
                fontSize: isWeb ? '12px' : '3.466vw',
                lineHeight: '16px',
              }}
            >
              {freeGift.title}
            </Typography>
            <Typography
              sx={{
                marginTop: isWeb ? '6px' : '8px',
                fontSize: isWeb ? '12px' : '3.466vw',
                lineHeight: '20px',
                color: waiMode ? colors.primaryBlack : colors.auxiliaryText,
                fontFamily: font.ir,
              }}
              component="div"
              dangerouslySetInnerHTML={{ __html: freeGift.content || '' }}
            />
          </Box>
        </Box>
      </Box>
    </GoodsDetailCollapse>
  );
}
